export enum SuperUserPosterControlOptions {
  ITEMS_LIST = 'ITEMS_LIST',
  POSTER_TOOLS = 'POSTER_TOOLS',
  TEST = 'TEST',
  TEST2 = 'TEST2',
}
